var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "points-mall-page" },
    [
      _c(
        "div",
        { staticClass: "hero" },
        [
          _vm._m(0),
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.openCreate } },
            [_vm._v("新增商品")]
          ),
        ],
        1
      ),
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.reload },
          model: {
            value: _vm.tab,
            callback: function ($$v) {
              _vm.tab = $$v
            },
            expression: "tab",
          },
        },
        [
          _c("el-tab-pane", { attrs: { label: "商品", name: "goods" } }),
          _c("el-tab-pane", { attrs: { label: "兑换单", name: "redeem" } }),
        ],
        1
      ),
      _c(
        "el-card",
        {
          attrs: { shadow: "never", "body-style": { padding: "0 20px 20px" } },
        },
        [
          _vm.tab === "goods"
            ? _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  attrs: { data: _vm.goodsList, size: "mini" },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "goods.goodsNo",
                      label: "编号",
                      "min-width": "140",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "goods.name",
                      label: "商品",
                      "min-width": "160",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "goods.pointsPrice",
                      label: "积分",
                      width: "90",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "goods.stock", label: "库存", width: "80" },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "goods.shelfStatus",
                      label: "状态",
                      width: "90",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "操作", width: "220" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return _vm._l(row.actions, function (action) {
                              return _c(
                                "el-button",
                                {
                                  key: action,
                                  attrs: { type: "text", size: "mini" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.runGoods(row, action)
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.goodsActionText(action)))]
                              )
                            })
                          },
                        },
                      ],
                      null,
                      false,
                      2691513815
                    ),
                  }),
                ],
                1
              )
            : _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  attrs: { data: _vm.redeemList, size: "mini" },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "redeem.redeemNo",
                      label: "编号",
                      "min-width": "140",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "redeem.goodsName",
                      label: "商品",
                      "min-width": "160",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "redeem.pointsCost",
                      label: "积分",
                      width: "90",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "redeem.status",
                      label: "状态",
                      width: "100",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "操作", width: "120" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return _vm._l(row.actions, function (action) {
                            return _c(
                              "el-button",
                              {
                                key: action,
                                attrs: { type: "text", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    return _vm.runRedeem(row, action)
                                  },
                                },
                              },
                              [_vm._v("履约")]
                            )
                          })
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("span", [_vm._v("POINTS MALL")]),
      _c("h2", [_vm._v("积分商城")]),
      _c("p", [_vm._v("商品上架、兑换与履约。")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }